import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AlertReduxState, PlaceholderEnum } from '@nx-fe/alert';
import { AlertState } from './alert.redux.state';

const getAlertInfo = createSelector(
  createFeatureSelector('alerts'),
  (state: AlertReduxState, placeholder: PlaceholderEnum) => {
    const alertState: AlertState = (state.alertStates || []).find(s => s.placeholder === placeholder);
    return alertState ? alertState.alerts : [];
  }
);

export const AlertQuery = {
  getAlertInfo,
};
